export const PATH_TO_WARNING_AUDIO = "/audio/warning.wav";

// Data channel labels
export const DATA_CHANNELS = {
  CHAT: 'chat',
  CONTROL: 'control',
  TELEMETRY: 'telemetry'
};

export const WAITING_TIME_BEFORE_AUTO_RECONNECT = 3000;
export const WAITING_TIME_TO_CHECK_FOR_DISCONNECTED = 3000;
export const MAX_NUMBER_OF_ATTEMP_TO_CHECK_FOR_DISCONNECTED = 3;

export const MAX_REQUEST_WAITING_TIME = 1000 * 30; // 30 seconds

export const PROTOCOL = window.location.protocol;
// export const PROTOCOL = "http:";
export const HOSTNAME = window.location.hostname;
// export const HOSTNAME = "10.252.117.23"; // keti desktop win
// export const HOSTNAME = "10.252.101.114";  // keti laptop_del ubuntu
// export const HOSTNAME = "175.126.123.199"; // cafe24 server
// export const PORT = "9980";

export const RUBBERNECK_COTURN_PORT = 3478;
export const RUBBERNECK_COTURN_HOST = HOSTNAME;

export const PATH_ROBOTS_LIST = "/robots";

// const HOST = HOSTNAME + ":" + PORT;
const HOST = HOSTNAME + "/api";

// const PATH_WS_USER = "/wsuser";
const PATH_WS_USER = "/wsuser/v_0_2";

export const getFetchURL = (relativePath) => {
  var url = PROTOCOL + "//" + HOST + relativePath;
  return url;
};

export const getRobotsListFetchURL = () => {
  return getFetchURL(PATH_ROBOTS_LIST);
};

export const getCalibrationSeverURL = (relativePath) => {
  var url = PROTOCOL + "//" + HOSTNAME + ":" + 8089 + relativePath;
  return url;
};

export const getCalibrationURL = () => {
  var relativePath = "/calibrate";
  var url = PROTOCOL + "//" + HOSTNAME + ":" + 8089 + relativePath;
  return url;
};

export const getConnect2RobotWsURL = () => {
  if (PROTOCOL !== "https:") return "ws://" + HOST + PATH_WS_USER;
  else return "wss://" + HOST + PATH_WS_USER;
};

const API_VERSION = "v1";
// const API_SERVER_HOST = `${HOSTNAME}:5100`;
const API_SERVER_HOST = `${HOSTNAME}/auth`;
const API_SERVER_URL = `${PROTOCOL}//${API_SERVER_HOST}/api/${API_VERSION}`;

const API_SERVER_STATIC_URL = `${PROTOCOL}//${API_SERVER_HOST}/static`;

// const CONN_MANAGER_SERVER_URL = `${HOSTNAME}:9980`;
const CONN_MANAGER_SERVER_URL = `${PROTOCOL}//${HOSTNAME}/api`;
const RAASDATA_SERVICE_URL = `${PROTOCOL}//${HOSTNAME}/raasdata`;

export const servicesUrlConfig = {
  ORGS_SERVICE_URL: `${API_SERVER_URL}/orgs`,
  USERS_SERVICE_URL: `${API_SERVER_URL}/users`,
  ROBOTS_SERVICE_URL: `${API_SERVER_URL}/robots`,
  AUTH_SERVICE_URL: `${API_SERVER_URL}/auth`,

  ROBOTS_CONNECTIONS_API: {
    base_url: `${CONN_MANAGER_SERVER_URL}/robots`,
    get_all: `${CONN_MANAGER_SERVER_URL}/robots`, // GET all robot connections
    get_by_user: `${CONN_MANAGER_SERVER_URL}/api/user/robots`, // GET robot connections by user_id
    get_by_robot_id: `${CONN_MANAGER_SERVER_URL}/api/user/robots`, // GET all robot clients by robot_id
    get_by_id: `${CONN_MANAGER_SERVER_URL}/robots`, // GET robot connection by connection_id
  },

  AUTH_API: {
    login: `${API_SERVER_URL}/auth/access-token`, // POST {username, password}
    register: `${API_SERVER_URL}/auth/register`, // POST
    refresh: `${API_SERVER_URL}/auth/refresh-token`, // POST {refreshToken}
    me: `${API_SERVER_URL}/auth/me`, // GET with Authorization: Bearer <accessToken>
    logout: `${API_SERVER_URL}/auth/logout`, // POST with Authorization: Bearer <accessToken>
    change_password: `${API_SERVER_URL}/auth/change-password`, // GET with Authorization: Bearer <accessToken>
    reset_password: `${API_SERVER_URL}/auth/reset-password`,
    forgot_password: `${API_SERVER_URL}/auth/forgot-password`,
    admin_set_user_password: `${API_SERVER_URL}/auth/set-user-password`, // POST {username, password} with Authorization: Bearer <accessToken>
    api_key: `${API_SERVER_URL}/auth/api-key`, // GET retrieve api-key, POST generate new api-key
  },
  USERS_API: {
    base_url: `${API_SERVER_URL}/users`,
    me: `${API_SERVER_URL}/users/me`,
    get_all: `${API_SERVER_URL}/users/`, // GET all users
    get_by_id: `${API_SERVER_URL}/users/`, // GET user by user_id
    orgs_roles: `${API_SERVER_URL}/users/orgs-roles/`, // GET all users and their organization roles
    update: `${API_SERVER_URL}/users/`, // PATCH update user by username (superuser only)
  },

  ROBOTS_API: {
    base_url: `${API_SERVER_URL}/robots`,
    me: `${API_SERVER_URL}/robots/me`, // GET robots of the current user
    my_robots: `${API_SERVER_URL}/robots/my-robots`, // GET robots created by the current user
    get_by_id: `${API_SERVER_URL}/robots/`, // GET robot by robot_id
    get_all: `${API_SERVER_URL}/robots/`, // GET all robots
    create: `${API_SERVER_URL}/robots/`, // POST create a new robot
    update: `${API_SERVER_URL}/robots/`, // PUT update a robot by robot_id
    delete: `${API_SERVER_URL}/robots/`, // DELETE a robot by robot_id
    static_url: `${API_SERVER_STATIC_URL}`,
    get_preset_icons: `${API_SERVER_URL}/robots/preset-icons`, // GET preset icons for selection
    getStaticUrl: (relativePath) => {
      return `${API_SERVER_STATIC_URL}/${relativePath}`;
    },
  },

  ROBOT_TYPES_API: {
    base_url: `${API_SERVER_URL}/robot_types`,
    get_all: `${API_SERVER_URL}/robot_types/`, // GET all robot types
    create: `${API_SERVER_URL}/robot_types/`, // POST create a new robot type
    update: `${API_SERVER_URL}/robot_types/`, // PATCH update a robot type by type_id
    delete: `${API_SERVER_URL}/robot_types/`, // DELETE a robot type by type_id
    upload_icon: `${API_SERVER_URL}/robot_types/`, // POST upload icon for a robot type
  },

  JOY_CONTROL_MAPPINGS_API: {
    base_url: `${API_SERVER_URL}/joy_control_mappings`,
    get_all: `${API_SERVER_URL}/joy_control_mappings/`, // GET all joy control mappings
    create: `${API_SERVER_URL}/joy_control_mappings/`, // POST create a new mapping
    update: `${API_SERVER_URL}/joy_control_mappings/`, // PATCH update a mapping by mapping_id
    delete: `${API_SERVER_URL}/joy_control_mappings/`, // DELETE a mapping by mapping_id
  },

  ORGS_API: {
    base_url: `${API_SERVER_URL}/orgs`,
    me: `${API_SERVER_URL}/orgs/me`, // GET organizations of the current user and their roles
    get_all: `${API_SERVER_URL}/orgs/`, // GET all organizations
    get_by_id: `${API_SERVER_URL}/orgs/`, // GET organization by org_id
    get_orgs_roles: `${API_SERVER_URL}/orgs/orgs-roles/`, // GET all organizations and their roles
    get_orgs_users: `${API_SERVER_URL}/orgs/orgs-users/`, // GET all organizations and their users
    create: `${API_SERVER_URL}/orgs/`, // POST create a new organization
    update: `${API_SERVER_URL}/orgs/`, // PUT update an organization by org_id
    delete: `${API_SERVER_URL}/orgs/`, // DELETE an organization by org_id
    add_member: `${API_SERVER_URL}/orgs/`, // POST add a member
    remove_member: `${API_SERVER_URL}/orgs/`, // DELETE remove a member
    add_robot: `${API_SERVER_URL}/orgs/`, // POST add a robot to an organization
    remove_robot: `${API_SERVER_URL}/orgs/`, // DELETE remove a
    upload_logo: (orgId) => `${API_SERVER_URL}/orgs/${orgId}/logo`,
    upload_logo_compact: (orgId) => `${API_SERVER_URL}/orgs/${orgId}/logo-compact`,
    delete_logo: (orgId) => `${API_SERVER_URL}/orgs/${orgId}/logo`,
    delete_logo_compact: (orgId) => `${API_SERVER_URL}/orgs/${orgId}/logo-compact`,
  },

  RAASDATA_API: {
    base_url: `${RAASDATA_SERVICE_URL}/api/v1`,
    // Multi-storage registry (one org — many storages)
    org_storages: (orgId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/storages`, // GET list, POST create
    org_storage: (orgId, storageId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/storages/${storageId}`, // GET/PATCH/DELETE one
    org_storage_test_connection: (orgId, storageId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/storages/${storageId}/test-connection`, // POST (managed only)
    org_storage_set_upload_target: (orgId, storageId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/storages/${storageId}/set-upload-target`, // POST
    org_clear_upload_target: (orgId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/upload-target`, // DELETE → fall back to central
    replication_rules: (orgId, storageId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/storages/${storageId}/replication-rules`, // POST
    replication_rule: (orgId, storageId, ruleId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/storages/${storageId}/replication-rules/${ruleId}`, // PATCH/DELETE
    replication_agents: (orgId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/replication-agents`, // GET list, POST create (token shown once)
    replication_agent: (orgId, agentId) =>
      `${RAASDATA_SERVICE_URL}/api/v1/orgs/${orgId}/replication-agents/${agentId}`, // DELETE revoke
  },
};

export const getApiUrl = (service, endpoint) => {
  if (servicesUrlConfig[service] && servicesUrlConfig[service][endpoint]) {
    return servicesUrlConfig[service][endpoint];
  }
  throw new Error(
    `API URL for service ${service} and endpoint ${endpoint} not found.`,
  );
};

export const getRobotIconPath = (robotInfo) => {
  return servicesUrlConfig.ROBOTS_API.getStaticUrl(
                      robotInfo?.icon_path ??
                      robotInfo?.robot_type?.icon_path ??
                      "/robot_type_icons/unknown_robot_type.png",
                    )
}
